module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ehhOMM/tc-custom/9781591811589.jpg?1720065287582",
      "alt": "This image is the cover for the book Shimmering World"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Shimmering World\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("\"In the face of the vastness, the magic, the unknown quality of life, and in a moment of true humility, we may discover the actuality that washes away all our concepts.\" The words in this exquisite little book provide us with a portal to that discovery. Pairing the stunning paintings of Richard Stodart with the profound words of Steven Harrison, The Shimmering World evokes the mysterious alchemy of stillness that transforms us. A marvelous gift for anyone who is moving through a great transition or wants to change their life, and a companion book for those who need to reach deeper within to come face to face with their truth.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Steven Harrison\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Steven Harrison is an international speaker on the topics of consciousness, human development, relationship and alternative education. He is the author of Doing Nothing, Being One, Getting to Where You Are, The Question to Life’s Answers, The Happy Child, What’s Next After Now? and more. His books have been translated for numerous foreign language editions.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0